import { useEffect, useRef } from 'react';

import { useToast } from '../components/index.ts';
import { useServiceWorker } from './useServiceWorker.ts';

/**
 * Offers the new version, once, and lets the user decide when.
 *
 * A toast rather than a banner or a modal, and it never reloads on its own:
 * taking over the page mid-entry would lose whatever was being typed.
 */
export function UpdateToast() {
  const { updateReady, applyUpdate } = useServiceWorker();
  const { showToast } = useToast();
  const announced = useRef(false);

  useEffect(() => {
    if (!updateReady || announced.current) return;

    announced.current = true;
    showToast({
      message: 'A new version of ICULogbook is ready.',
      // Long enough to notice on a phone in one hand, and it comes back on the
      // next load anyway if it is missed.
      duration: 20_000,
      actions: [{ label: 'Reload', onAction: applyUpdate }],
    });
  }, [updateReady, applyUpdate, showToast]);

  return null;
}
